<forge-scaffold [ngClass]="scaffoldClasses">
    <omni slot="header" *ngIf="showOmni" [backBar]="false">
    </omni>

    <ng-container *ngIf="!isModal; else modal">
        <forge-drawer #leftMenu slot="body-left" role="navigation" direction="left" [open]="menuOpen"
                    [tabindex]="leftMenuTabIndex" (forge-modal-drawer-close)="closeMenu()" class="navmenu">
            <app-menu></app-menu>
        </forge-drawer>
    </ng-container>

    <div slot="body" [ngClass]="{'embedded': embedded}" fxLayout="row" fxLayoutAlign="center" class="content" id="content" tabindex="-1" role="main">
        <div fxFill>
            <router-outlet></router-outlet>
        </div>
    </div>
</forge-scaffold>

<ng-template #modal>
    <forge-modal-drawer *ngIf="isModal" #leftMenu slot="body-left" role="navigation" direction="left" [open]="menuOpen"
                        [tabindex]="leftMenuTabIndex" (forge-modal-drawer-close)="closeMenu()" class="navmenu">
        <app-menu></app-menu>
    </forge-modal-drawer>
</ng-template>
